module.exports = {
  "name": "bsl",
  "client": "STANDING EVT",
  "description": "Mobile app for BS Lyon",
  "validLangs": ["fr"],
  "version": {
    "mainVersion": "2.0.0",
    "buildVersion": {
      "iOS": "33",
      "android": "32",
      "web": "33"
    }
  },
  "native": {
    "author": "Mobile-Spot",
    "backgroundColor": "0xffffff",
    "iosBuildTarget": "11.0",
    "androidFadeSplashScreenDuration": 750,
    "androidTargetSdkVersion": 31,
    "androidSigning": {
      "keyAlias": "mobilespot-bsl",
      "keyStorePassword": "jee1Uu0Hieloh7bi"
    },
    "app": "app-react"
  },
  "undeliveredFolders": ["source", "exports"],
  "crypto": false,
  "web": {}
};